class ContractRule {
  constructor(rule) {
    this.botId = rule.botId
    this.platform = rule.platform
    this.name = rule.name || ''
    this.subscribers = rule.subscribers || 0
    this.dailyPush = rule.dailyPush || 0
    this.internalApiRequests = rule.internalApiRequests || 0
    this.externalApiRequests = rule.externalApiRequests || 0
  }

  setPlatform(platform) {
    this.platform = platform
  }

  setName(name) {
    this.name = name
  }

  deepClone() {
    return { ...this }
  }

  toJSON() {
    return {
      botId: this.botId,
      subscribers: this.subscribers,
      dailyPush: this.dailyPush,
      internalApiRequests: this.internalApiRequests,
      externalApiRequests: this.externalApiRequests
    }
  }
}

export function createRule(rule) {
  return new ContractRule(rule)
}
